import {GetterTree} from "vuex";
import {PaperclipWidgetState} from "@/apps/PaperclipWidget/models/paperclip-widget-state";


export default <GetterTree<PaperclipWidgetState, PaperclipWidgetState>>{
    isCollapsed: (state): boolean => {
        return state.isCollapsed;
    },
}

